import { useEffect, useState } from 'react';
import {
  ArrowLeft,
  BarChart3,
  Building2,
  CreditCard,
  FileClock,
  KeyRound,
  LayoutDashboard,
  LifeBuoy,
  LogIn,
  Users,
  Wallet,
} from 'lucide-react';
import { api } from '../../api/cliente';
import { Estrutura, type GrupoNavegacao } from '../../componentes/Estrutura';
import { BotaoLink } from '../../componentes/ui';
import cssEstrutura from '../../componentes/Estrutura.module.css';

/**
 * Painel de administração — separado do painel do cliente.
 *
 * Não é só organização visual. Aqui não existe nenhuma ação que baixe XML,
 * gaste crédito ou consuma o provedor externo: é uma superfície de LEITURA e
 * CONTROLE. Misturar as duas coisas numa aba do painel do cliente levaria, com
 * o tempo, a alguém operar a conta de um cliente sem perceber em qual contexto
 * está — por isso o selo "Admin" fica sempre visível ao lado da marca.
 */
export function LayoutAdmin() {
  const [suporteNaoLidas, setSuporteNaoLidas] = useState(0);

  // Conversas com mensagem nova de cliente: o número ao lado de "Suporte".
  useEffect(() => {
    let vivo = true;
    const buscar = () => {
      void api<{ total: number }>('/admin/suporte/nao-lidas')
        .then((r) => {
          if (vivo) setSuporteNaoLidas(r.total);
        })
        .catch(() => undefined);
    };
    buscar();
    const t = setInterval(buscar, 30_000);
    return () => {
      vivo = false;
      clearInterval(t);
    };
  }, []);

  const grupos: GrupoNavegacao[] = [
    {
      itens: [
        { para: '/admin', rotulo: 'Visão geral', icone: <LayoutDashboard />, exato: true },
        { para: '/admin/clientes', rotulo: 'Clientes', icone: <Users /> },
        {
          para: '/admin/suporte',
          rotulo: 'Suporte',
          icone: <LifeBuoy />,
          contador: suporteNaoLidas,
        },
      ],
    },
    {
      titulo: 'Produto',
      itens: [
        { para: '/admin/captura', rotulo: 'Captura automática', icone: <Building2 /> },
        { para: '/admin/visitas', rotulo: 'Visitas e conversão', icone: <BarChart3 /> },
      ],
    },
    {
      titulo: 'Financeiro',
      itens: [
        { para: '/admin/pagamentos', rotulo: 'Pagamentos', icone: <CreditCard /> },
        { para: '/admin/financeiro', rotulo: 'Financeiro', icone: <Wallet /> },
      ],
    },
    {
      titulo: 'Segurança',
      itens: [
        { para: '/admin/api-keys', rotulo: 'Chaves de API', icone: <KeyRound /> },
        { para: '/admin/acessos', rotulo: 'Acessos', icone: <LogIn /> },
        { para: '/admin/auditoria', rotulo: 'Auditoria', icone: <FileClock /> },
      ],
    },
  ];

  return (
    <Estrutura
      inicio="/admin"
      contexto="Admin"
      grupos={grupos}
      rodapeLateral={
        <BotaoLink
          to="/painel"
          aparencia="discreto"
          larguraTotal
          icone={<ArrowLeft />}
          className={cssEstrutura.voltarLateral}
        >
          Voltar ao meu painel
        </BotaoLink>
      }
      atalhosUsuario={[{ para: '/painel', rotulo: 'Meu painel', icone: <ArrowLeft /> }]}
    />
  );
}
